import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import ThirdEventBanner from '../../../assets/gui/third_purchase_event_popup.png'

interface EventTermsNoticeModalProps {
  order: () => void
}

export function EventTermsNoticeModal({ order }: EventTermsNoticeModalProps) {
  const { closeModal } = useContext(ModalContext)

  const closeEventTermsNoticeModal = () => {
    closeModal(MODALS_ID.ORDER_EVENT_NOTICE)
  }

  return (
    <Modal id={MODALS_ID.ORDER_EVENT_NOTICE}>
      <Content>
        <Text size={16} weight={500} lineHeight={24} block={true}>
          (선택)항목에 동의하시면,
          <br />
          많은 혜택을 드려요.
          <br />
          이벤트에 참여하시겠어요?
        </Text>
        <ImageBox>
          <img src={ThirdEventBanner} alt="3호 청약 이벤트 팝업" />
        </ImageBox>
      </Content>
      <Modal.Footer>
        <Button type="primary" onClick={closeEventTermsNoticeModal}>
          네
        </Button>
        <Button
          onClick={() => {
            closeEventTermsNoticeModal()
            order()
          }}
        >
          아니오
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`

const ImageBox = styled.div`
  overflow: hidden;
  width: 100%;
  height: fit-content;
  border-radius: 8px;
  > img {
    width: 100%;
  }
`
